<template>
    <div class="popup-container" :style="{ position: 'fixed', left: pos[0], top: pos[1], zIndex: 999999 }">
        <ul>
            <li>时间：{{ parseTime(item.data.ts) }}</li>
            <li>经度：{{ convertLon(item.data.lon, 4) }}</li>
            <li>纬度：{{ convertLat(item.data.lat, 4) }}</li>
            <li>风速：{{ item.data.p1/100 }}(m/s)</li>
            <li>风力：{{ item.data.p2 }}(级)</li>
            <li>湿度：{{ item.data.p5/10 }}(%)</li>
            <li>温度：{{ item.data.p6/10 }}(℃)</li>
            <li>光照：{{ item.data.p13 }}(百Lux)</li>
            <li>雨量：{{ item.data.p14/10 }}(mm)</li>
            <li>大气压：{{ item.data.p10/10 }}(kPa)</li>
            <li>设备号：{{ item.data.sn }}</li>
        </ul>
        <!-- <span class="close-btn" @click="close">X</span> -->
    </div>
</template>

<script>
import { lonToDegreeMinString, latToDegreeMinString } from '@/utils';
export default {
    name: 'WeatherPopup',
    inject: ['instanceProvide'],
    props: {
        item: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {

        }
    },
    computed: {
        pos() {
            //目标信息中的经纬度坐标转换成EN坐标,再转换成像素坐标
            const position = this.item.getCenter()
            const [x, y] = this.instanceProvide.map.getViewport().enPointToPixelPoint(position);
            return [`${Math.round(x) + 16}px`, `${Math.round(y) - 10}px`]
        }
    },
    mounted() {
        // 绑定到body上
        document.querySelector('body').appendChild(this.$el);
    },
    methods: {
        convertLon(lon){
            return lonToDegreeMinString(lon, 4)
        },
        convertLat(lat){
            return latToDegreeMinString(lat, 4)
        },
        close(){

        }
    }
}
</script>

<style lang="scss" scoped>
.popup-container {
    width: 210px;
    padding: 10px;
    background-color: #fff;
    // color: #fff;
    border-radius: 4px;
    font-size: 14px;
    z-index: 999;

    .close-btn {
        position: absolute;
        top: -8px;
        right: -10px;
        background-color: #27619f;
        width: 20px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        border-radius: 50%;
        color: #ebeaea;
        cursor: pointer;
        border: 2px solid #FFF;
        font-size: 12px;
    }
}
</style>

